import type { TFunction } from "i18next";

// Relative "N daqiqa oldin" from an ISO timestamp, localized via i18n.
// Returns the "never" string when last_login is null/empty.
export function relativeTime(
  iso: string | null | undefined,
  t: TFunction,
): string {
  if (!iso) return t("customers.never");
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return t("customers.never");

  const diffMs = Date.now() - then;
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return t("time.justNow");
  if (mins < 60) return t("customers.ago", { value: t("time.minutes", { count: mins }) });

  const hours = Math.floor(mins / 60);
  if (hours < 24) return t("customers.ago", { value: t("time.hours", { count: hours }) });

  const days = Math.floor(hours / 24);
  return t("customers.ago", { value: t("time.days", { count: days }) });
}

// Absolute calendar date (DD.MM.YYYY, locale-aware) for the registration timestamp.
// Returns "" for null/empty/invalid so callers can render unconditionally.
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(undefined, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
}
